export default "__VITE_ASSET__DBSUS$HW__"